/* @flow */

export default {
  root: {
    position: 'relative',

    // IE11: prevents the Avatar from shrinking without using problematic
    // `flex:1`
    flexShrink: 0,
  },
  badge: {
    position: 'absolute',
  },
  'badge-xsmall': {
    top: -4,
    right: -2,
  },
  'badge-small': {
    top: 0,
    right: 0,
  },
  'badge-medium': {
    top: 0,
    right: 0,
  },
  'badge-large': {
    top: 3,
    right: 3,
  },
  'badge-xlarge': {
    top: 3,
    right: 3,
  },
  'badge-xxlarge': {
    top: 3,
    right: 3,
  },
};
